export default "__VITE_ASSET__DdK$Tw6C__"